<template>
  <div class="home" prerender>
    <EffectScene id="scene"/>
    <EffectArticles id="articles"/>
    <EffectLegislator id="legislator"/>
    <TheComments :url="projectUrl"/>
    <TheFooter/>
  </div>
</template>

<script>
import EffectScene from '@/components/sections/EffectScene'
import EffectArticles from '@/components/sections/EffectArticles'
import EffectLegislator from '@/components/sections/EffectLegislator'
import TheComments from '@/components/TheComments'
import TheFooter from '@/components/TheFooter'

export default {
  name: 'home',
  components: {
    EffectScene,
    EffectArticles,
    EffectLegislator,
    TheComments,
    TheFooter
  },
  inject: [ 'projectUrl' ]
}
</script>

<style lang="scss">
.home {
  position: relative;
  background: #efefef;
}
</style>
